import React from 'react'
import "./services-component/css/services.css"
import WhatWeDo from './component/WhatWeDo'
import img1 from './services-component/images/img1.jpg'
import AwardWinning from './services-component/AwardWinning'
import ServicesCounter from './services-component/ServicesCounter'
import OurClientSay from './services-component/OurClientSay'
import CaseStudy from './services-component/CaseStudy'
import ContactArea from './services-component/ContactArea'
import Top_heading from './component/Top_heading'


export default function Services() {
  return (
    <>
      
      <Top_heading Heading="SERVICES"/>
        {/* section2 */}
        {/* <div className="container ser-company">
            <div className="row row-cols-5 ser-rows">
                <div className="col services-company">
                <div className="background-company">
                    <div className="ser-com-img">
                         <img src={img1} alt="" />
                    </div>
                </div>
            </div>
            <div className="col services-company">
                <div className="background-company">
                    <div className="ser-com-img">
                         <img src={img1} alt="" />
                    </div>
                </div>
            </div>
            <div className="col services-company">
                <div className="background-company">
                    <div className="ser-com-img">
                         <img src={img1} alt="" />
                    </div>
                </div>
            </div>
            <div className="col services-company">
                <div className="background-company">
                    <div className="ser-com-img">
                         <img src={img1} alt="" />
                    </div>
                </div>
            </div>
            <div className="col services-company">
                <div className="background-company">
                    <div className="ser-com-img">
                         <img src={img1} alt="" />
                    </div>
                </div>
            </div>
            </div>

        </div> */}
        <AwardWinning/>
        <ServicesCounter/>
        
          


      {/* section4 */}
      <WhatWeDo/>

      {/* <CaseStudy/>

      <OurClientSay/> */}

      <ContactArea/>

    </>
  )
}
